import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieLangForm, useSerieLang } from '@/features/series-lang-management';
import { Skeleton } from '@/shared/ui/atoms';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/series/$serieId/langs/$langId/')({
  component: SerieLangEditPage,
});

/** Página de edição de Idioma da Série. */
export function SerieLangEditPage() {
  const { t } = useTranslation('series');
  const { serieId: serieIdParam, langId } = Route.useParams();
  const serieId = Number(serieIdParam);
  const navigate = useNavigate();

  const { lang, isLoading } = useSerieLang(serieId, Number(langId));

  const goBack = () =>
    void navigate({ to: '/series/$serieId/langs', params: { serieId: serieIdParam } });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('langs.form.editTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('langs.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series/$serieId/langs" params={{ serieId: serieIdParam }}>
                {t('langs.breadcrumb.langs')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('langs.form.editTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      {isLoading ? (
        <Skeleton className="h-[420px] w-full rounded-sm" />
      ) : (
        <SerieLangForm serieId={serieId} lang={lang ?? null} onSaved={goBack} onCancel={goBack} />
      )}
    </div>
  );
}
